import {Component, signal} from '@angular/core';
import {RouterOutlet} from '@angular/router';

@Component({
  selector: 'app-game-table',
  imports: [
    RouterOutlet
  ],
  templateUrl: './game-table.component.html',
  styleUrl: './game-table.component.css',
})
export class GameTableComponent {



}








